import * as React from 'react';
import { useState } from 'react';
import { useSpring } from 'react-spring';
import { Parallax } from 'react-scroll-parallax';
import { Parallax as SwiperParallax, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

import './style.scss';

import Slide0 from './slides/slide_0';
import Slide1 from './slides/slide_1';
import Slide2 from './slides/slide_2';
import Slide3 from './slides/slide_3';
import Slide4 from './slides/slide_4';
import Slide5 from './slides/slide_5';
import Slide6 from './slides/slide_6';
import Slide7 from './slides/slide_7';

const MegaCarousel = () => {
  const [swiper, setSwiper] = useState(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const [direction, setDirection] = useState('vertical');
  const [spring, setSpring] = useSpring(() => ({ xy: [0, 0], config: { mass: 10, tension: 550, friction: 140 } }));

  const slides = [
    {
      label: 'Schemes in force',
      content: <Slide0 spring={spring} />,
    },
    {
      label: 'Approved schemes',
      content: <Slide1 spring={spring} />,
    },
    {
      label: 'Public consultations',
      content: <Slide2 spring={spring} />,
    },
    {
      label: 'Waiver requests',
      content: <Slide3 spring={spring} />,
    },
    {
      label: 'Association members subject to schemes',
      content: <Slide4 spring={spring} />,
    },
    {
      label: 'Responding to emerging risks in the legal profession',
      content: <Slide5 spring={spring} />,
    },
    {
      label: 'Decrease in claims exceeding 50% of scheme monetary ceilings',
      content: <Slide6 spring={spring} />,
    },
    {
      label: 'Root cause analysis as a risk management tool',
      content: <Slide7 spring={spring} />,
    },
  ];

  const handleDirectionChange = () => {
    if (window.innerWidth < 1024 && direction !== 'horizontal') {
      setDirection('horizontal');
    } else if (window.innerWidth >= 1024 && direction !== 'vertical') {
      setDirection('vertical');
    }
  };

  let calc;

  if (typeof window !== `undefined`) {
    handleDirectionChange();

    window.addEventListener('resize', () => {
      handleDirectionChange();
    });

    calc = (x, y) => [x - window.innerWidth / 2, y - window.innerHeight / 2];
  }

  return (
    <section
      role="presentation"
      className="mega-carousel"
      onMouseMove={({ clientX: x, clientY: y }) => setSpring({ xy: calc(x, y) })}
    >
      <Parallax className="background" y={[-30, 30]}>
        <div className="bg1" />
        <div className="bg2" />
      </Parallax>

      <div className="container">
        <h2 className="section-title">2020/21 Year at a Glance</h2>
        <div className="carousel-wrapper">
          <Swiper
            autoHeight
            modules={[SwiperParallax, A11y]}
            direction={direction}
            parallax={true}
            onSwiper={instance => setSwiper(instance)}
            onSlideChange={swiper => setActiveSlide(swiper.activeIndex)}
          >
            {slides.map((slide, i) => (
              <SwiperSlide key={i}>{slide.content}</SwiperSlide>
            ))}
          </Swiper>

          <div className="slide-list">
            <ul>
              {slides.map((slide, i) => (
                <li key={i} className={`slide-list-item ${activeSlide === i ? 'is-active' : ''}`}>
                  <div
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                      swiper.slideTo(i);
                      setActiveSlide(i);
                    }}
                    onKeyDown={() => {
                      swiper.slideTo(i);
                      setActiveSlide(i);
                    }}
                    data-sal="slide-up"
                    data-sal-duration="1000"
                    data-sal-delay="300"
                    data-sal-easing="ease"
                  >
                    <span>{slide.label}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MegaCarousel;
